/* eslint-disable no-console */
import '@/theme/partials/_status.scss';
import '@/theme/partials/_amount.scss';

import { Capacitor } from '@capacitor/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonLabel,
  IonLoading,
  IonModal,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
} from '@ionic/react';
import classNames from 'classnames';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { chevronBackOutline } from 'ionicons/icons';
import {
  Fragment, useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import CaretLeftIcon from '@/assets/icons/keyboard-arrow-left.svg';
import Button from '@/components/common/Button';
import SuccessModal from '@/components/common/SucessModal';
import OperationManged from '@/components/operations/ManagedModal/OperationManaged';
import {
  OPERATION_DASHBOARD,
  OPERATION_DASHBOARD_DETAIL,
  ROUTES_PATH,
} from '@/constants';
import { Refund } from '@/entities/dashboard';
import { RefundStatus, RefundType } from '@/entities/operationStatus';
import ENVIRONMENT from '@/environments/environment';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import useModal from '@/hooks/useModal';
import { ClientTaxonomyEvents, ClientTaxonomyProps } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import {
  InitialStatus,
  Name,
} from '@/interfaces/OperationsDashboardInterface/OperationsDashboardInterface';
import { postLeads } from '@/redux/auth/authAPI';
import {
  checkmanagedOffers, checkpreferredOfferAndNoPreferredOffer, existingCommercialOffers, existingEcoOffers,
} from '@/redux/commercialOffers/commercialOffers';
import { saveEcommercePlatformData } from '@/redux/ecommerceWidget/ecommerceWidget';
import { getPlatform } from '@/redux/ecommerceWidget/ecommerceWidgetAPI';
import { addError } from '@/redux/error/error';
import { existingCartId } from '@/redux/invoiceManaged/cartIdManaged';
import { saveMerchantData } from '@/redux/merchant/merchant';
import {
  clearOperationData,
  saveOperationData,
  saveOperationOrderData,
  updateOperationStatus,
} from '@/redux/operation/operations';
import {
  deleteOperation, getDashboard, getDashboards, getMerchants,
} from '@/redux/operation/operationsAPI';
import {
  CancelReason, CommercialOffer, FlowCommercialOffer, FlowType, Merchant,
} from '@/redux/operation/operationsInterface';
import { clearIsPreferredOffer, clearOrderManagedData, saveIsPreferredOffer } from '@/redux/orderManaged/orderManaged';
import { Analytics } from '@/services/analytics';
import { setClaritySessionId, setClarityUserId } from '@/services/clarity';
import { fileOpenerService } from '@/services/fileOpener';
import { storageService } from '@/services/storage';
import { RootState } from '@/store';
import { retrieveCommercialOffers } from '@/utils/commercialOfferHelper';
import { getCustomerFullName } from '@/utils/customerHelper';
import {
  convertDateFormatData,
  DateAddedMonths,
  getTodayDate,
} from '@/utils/dateHelper';
import { pricesHelper } from '@/utils/pricesHelper';

import styles from './OperationDetail.module.scss';

const URL_CEX = ENVIRONMENT.URL_PEPPERONE;
const allowedOrigins = [
  ENVIRONMENT.URL_ECOMMERCE,
  ENVIRONMENT.URL_ECOMMERCE_2,
  ENVIRONMENT.URL_ECO,
  ENVIRONMENT.URL_ECO_2,
];

export default function OperationDetail() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const operationData = useSelector((state: any) => state.operation);
  const merchant = useSelector((state: RootState) => state.merchantData.data);
  const { presentModal: presentSuccessModal } = useModal(SuccessModal);
  const merchantInfo = useSelector((state: RootState) => state.merchantData.data);

  const isECO = sessionStorage.getItem('pepperCommercialOffersECO');

  const [commercialOffer, setCommercialOffer] = useState<any>(
    operationData?.data?.data,
  );
  const [merchantData, setMerchantData] = useState<Merchant | null>(null);
  const [refundAvailable, setRefundAvailable] = useState<boolean>(true);
  const [flowSus, setFlowSus] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [cexUrl, setCexUrl] = useState('');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const queryParams = new URLSearchParams(location.search);
  const creditProposalID = queryParams.get('credit_proposal_id');
  const cartID = queryParams.get('cart_id');
  const [cookieProposalReference, setCookieProposalReference] = useState(storageService.hasAGCode());
  const [segment, setSegment] = useState(0);
  const [requestedAmount, setRequestedAmount] = useState(0);
  const [principalAmount, setPrincipalAmount] = useState(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [retakenEco, setRetakenEco] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isTablet = useMediaQuery(Breakpoint.Tablet);
  const isDesktop = useMediaQuery(Breakpoint.Tablet);

  const { presentModal: presentManagedModal, dismissModal: dismissManagedModal } = useModal(OperationManged);

  const reloadPage = async () => {
    try {
      let newFilterValues;
      if (cartID) {
        newFilterValues = {
          offset: 0,
          limit: 20,
          nameOrDni: '',
          cart_id: `&cart_id=${cartID}`,
          from_date: '',
          to_date: '',
          buttons: '',
        };
      } else if (creditProposalID) {
        newFilterValues = {
          offset: 0,
          limit: 20,
          nameOrDni: '',
          cart_id: '',
          credit_proposal_id: creditProposalID,
          from_date: '',
          to_date: '',
          buttons: '',
        };
      }
      if (newFilterValues) {
        const dashboardApiResponse = await getDashboards(newFilterValues);
        const newCommercialOffer = dashboardApiResponse.data.dashboards[0];
        setCommercialOffer(newCommercialOffer);
        handleSelectButton(newCommercialOffer);
        dispatch(updateOperationStatus(true));
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const getPurchaseAmount = () => {
    if (commercialOffer?.proposal) {
      setRequestedAmount(commercialOffer.proposal.requested_amount);
      setPrincipalAmount(commercialOffer.proposal.principal_amount);
    } else if (commercialOffer?.order) {
      setRequestedAmount(commercialOffer.order.total_price);
      setPrincipalAmount(commercialOffer.order.total_price);
    }
  };

  const canRetake = () => merchantData?.level !== 1
    && merchantData?.level !== 2
    && (commercialOffer.product === 'CEX'
      || commercialOffer.product === 'PLS'
      || (commercialOffer.product === 'SUS' && commercialOffer.business_status === 'APP')
      || (commercialOffer.product === 'ECO' && retakenEco))
    && (commercialOffer.application === 'IAM'
      || commercialOffer.application === 'ICH'
      || commercialOffer.application === 'NCH'
      || commercialOffer.application === 'IEC'
      || commercialOffer.application === 'EC3'
    );

  const canReject = () => merchantData?.level !== 1
    && merchantData?.level !== 2
    && (commercialOffer.product === 'CEX'
      || commercialOffer.product === 'PLS'
      || (commercialOffer.product === 'SUS' && commercialOffer.business_status === 'APP')
    )
    && (commercialOffer.application === 'IAM'
      || commercialOffer.application === 'ICH'
      || commercialOffer.application === 'NCH'
    );

  const handleSelectButton = (commercialOffer: any) => {
    switch (commercialOffer.business_status) {
      case 'APP':
      case 'CAP':
        return (
          <Fragment key="operation-detail-buttons">
            {canReject()
              && (
                <IonButton
                  id="button-reject"
                  shape="round"
                  className={styles.secondaryBtnOpDetail}
                  onClick={handleRejection}
                >
                  <span>Rechazar operación</span>
                </IonButton>
              )}
            {canRetake()
              && (
                <Button
                  id="button-retake"
                  shape="round"
                  className={styles.continueBtnOpDetail}
                  onClick={() => {
                    Analytics.registerAnalyticsEvent({
                      [ClientTaxonomyEvents.OPEN_PEPPERONE]: {},
                    });
                    handleContinuation();
                  }}
                >
                  Retomar operación
                </Button>
              )}
          </Fragment>
        );
      case 'TUD':
        if (canRetake()) {
          return (
            <Button
              id="button-retake"
              shape="round"
              className={styles.continueBtnOpDetail}
              onClick={() => {
                Analytics.registerAnalyticsEvent({
                  [ClientTaxonomyEvents.OPEN_PEPPERONE]: {},
                });
                handleContinuation();
              }}
            >
              Retomar operación
            </Button>
          );
        }
        break;
      case 'PAI':
      case 'EXT':
        if (
          commercialOffer.product === 'CEX'
          || commercialOffer.product === 'ECO'
          || commercialOffer.product === 'SUS'
        ) {
          const suscriptionButton = !!(
            commercialOffer.product === 'SUS'
            && commercialOffer?.loan?.allowed_refinancing
          );
          return (
            <div id="contentButtonsMobile" className={styles.operationsDetailContentButtonsDesktop}>
              <Button
                id="button-refund"
                fill={suscriptionButton ? 'outline' : 'solid'}
                onClick={() => {
                  history.push(
                    commercialOffer?.order
                      ? `${ROUTES_PATH.OPERATION_REFUND}?cart_id=${cartID}`
                      : `${ROUTES_PATH.OPERATION_REFUND}?credit_proposal_id=${creditProposalID}`,
                  );
                }}
              >
                Tramitar devolución
              </Button>
              {merchantData?.level !== 1
                && merchantData?.level !== 2
                && suscriptionButton && (
                  <Button
                    id="button-extend"
                    shape="round"
                    className={styles.mainBtnOpDetail}
                    onClick={() => {
                      handleNewOperation();
                    }}
                  >
                    Ampliar producto
                  </Button>
              )}
            </div>
          );
        }
        break;
      case 'PRF':
        if (refundAvailable) {
          if (
            commercialOffer.product === 'CEX'
            || commercialOffer.product === 'ECO'
            || commercialOffer.product === 'SUS'
          ) {
            const suscriptionButton = !!(
              commercialOffer.product === 'SUS'
              && commercialOffer?.loan?.allowed_refinancing
            );
            return (
              <div id="contentButtonsMobile" className={styles.operationsDetailContentButtonsDesktop}>
                <Button
                  id="button-refund"
                  shape="round"
                  fill={suscriptionButton ? 'outline' : 'solid'}
                  onClick={() => history.push(
                    commercialOffer?.order
                      ? `${ROUTES_PATH.OPERATION_REFUND}?cart_id=${cartID}`
                      : `${ROUTES_PATH.OPERATION_REFUND}?credit_proposal_id=${creditProposalID}`,
                  )}
                >
                  Tramitar devolución
                </Button>
                {merchantData?.level !== 1
                  && merchantData?.level !== 2
                  && suscriptionButton && (
                    <Button
                      id="button-extend"
                      shape="round"
                      className={styles.mainBtnOpDetail}
                      onClick={() => {
                        handleNewOperation();
                      }}
                    >
                      Ampliar producto
                    </Button>
                )}
              </div>
            );
          }
        }
        break;
      case 'EXP':
        if (
          merchantData?.level !== 1
          && merchantData?.level !== 2
          && commercialOffer.product === 'ECO'
          && (commercialOffer.application === 'IEC' || commercialOffer.application === 'EC3')
          && retakenEco
        ) {
          return (
            <Button
              id="button-retake"
              shape="round"
              className={styles.continueBtnOpDetail}
              onClick={() => {
                Analytics.registerAnalyticsEvent({
                  [ClientTaxonomyEvents.OPEN_PEPPERONE]: {},
                });
                handleContinuation();
              }}
            >
              Retomar operación
            </Button>
          );
        }
        break;
      case 'RTK':
      case 'WTD':
      case 'NRF':
      case 'NTP':
      case 'TRF':
        break;
      default:
        break;
    }
  };

  const changeName = (name: string) => {
    const {
      PAI, WTD, TRF, PRF, NRF, APP, CAP, NTP, EXP, TUD, RTK, EXT,
    } = Name;
    const {
      Abonada,
      Denegada,
      DevTotal,
      DevParcial,
      PteDevolucion,
      Aprobada,
      Captura,
      PteDesembolso,
      Caducada,
      Rechazada,
      Retomada,
      Ampliada,
    } = InitialStatus;
    switch (name) {
      case Denegada:
        return WTD;
      case Abonada:
        return PAI;
      case DevTotal:
        return TRF;
      case DevParcial:
        return PRF;
      case PteDevolucion:
        return NRF;
      case Aprobada:
        return APP;
      case Captura:
        return CAP;
      case PteDesembolso:
        return NTP;
      case Caducada:
        return EXP;
      case Rechazada:
        return TUD;
      case Retomada:
        return RTK;
      case Ampliada:
        return EXT;
      default:
        break;
    }
  };

  const openModal = (open: boolean) => {
    setModalOpen(open);
  };

  const listener = (event: any) => {
    if (event.origin === URL_CEX) {
      if (event.data?.message === 'Pepper - Signature Contract') {
        fileOpenerService.openContract(event.data.contractString);
      } else if (event.data.message === 'close CEX') {
        window.removeEventListener('message', listener);
        openModal(false);
        reloadPage();
      }
    } else if (allowedOrigins.includes(event.origin)) {
      if (event.data?.message === 'Pepper - Signature Contract') {
        fileOpenerService.openContract(event.data.contractString);
      } else if (event.data.message === 'close iframe') {
        window.removeEventListener('message', listener);
        dismissManagedModal();
        reloadPage();
      }
    }
  };

  const getLead = async (): Promise<string | undefined> => {
    try {
      const leadsResponse = await postLeads();
      sessionStorage.setItem('leadToken', leadsResponse?.data.token);
      const expirationDate = new Date();
      expirationDate.setSeconds(
        expirationDate.getSeconds() + leadsResponse?.data.expires_in,
      );
      sessionStorage.setItem('expiresLeads', expirationDate.toUTCString());
      return leadsResponse?.data.token;
    } catch (err) {
      dispatch(addError(''));
    }
  };

  const checkCommercialOfferAvailability = async (
    totalPrice: number,
  ): Promise<boolean> => {
    const offerS = sessionStorage.getItem('pepper-commercial-offers-S');
    let commercialOffers;
    // comprobamos si ya tenemos las ofertas comerciales en el sessionStorage
    if (!offerS) {
      // si no las tenemos las recuperamos
      commercialOffers = await retrieveCommercialOffers();
      if (commercialOffers) {
        sessionStorage.setItem(
          'pepper-commercial-offers-S',
          JSON.stringify(commercialOffers),
        );
      }
    } else {
      // esto es lo que se guarda en el sessionStorage y se recupera
      commercialOffers = JSON.parse(offerS);
    }
    if (commercialOffers) {
      // recorremos las ofertas comerciales para poder filtrar por el flujo ECO
      // eslint-disable-next-line no-restricted-syntax
      for (const offer of commercialOffers) {
        if (offer.flow === 'ECO') {
          // comprobamos si el importe total del pedido esta dentro del rango de financiacion
          const minAvailability: number = Math.min(
            ...offer.commercial_offers.map(
              (commercial_offer: any) => commercial_offer.min_amount,
            ),
          );
          const maxAvailability: number = Math.max(
            ...offer.commercial_offers.map(
              (commercial_offer: any) => commercial_offer.max_amount,
            ),
          );
          // console.log(`${totalPrice} totalPrice`);
          if (minAvailability > totalPrice || maxAvailability < totalPrice) {
            console.log(
              `¡Vaya! El importe de esa referencia (${totalPrice}€) está fuera del rango de financiación. Recuerda que tiene que estar entre ${minAvailability} y ${maxAvailability}`,
            );
            return false;
          }
        }
      }
    }

    return true;
  };

  const handleNewOperation = async () => {
    const lead_token = sessionStorage.getItem('leadToken');
    const lead_token_expiration = sessionStorage.getItem('expiresLeads');
    const loanId = commercialOffer.loan.loan_id;
    const currentTime = new Date();
    let url;
    if (
      lead_token
      && lead_token_expiration
      && new Date(lead_token_expiration) > currentTime
    ) {
      url = `${URL_CEX}/?lead_token=${lead_token}&loan_id=${loanId}&refinanced_proposal=${creditProposalID}${Capacitor.isNativePlatform() ? '&is_app=true' : ''
      }`;
      setCexUrl(url);
      window.addEventListener('message', listener, false);
      Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.OPEN_PEPPERONE]: { type: 'SUSCRIPTION' } });
      setModalOpen(true);
    } else {
      const tokenResponse = await getLead();
      if (tokenResponse) {
        url = `${URL_CEX}/?lead_token=${tokenResponse}&loan_id=${loanId}&refinanced_proposal=${creditProposalID}${Capacitor.isNativePlatform() ? '&is_app=true' : ''
        }`;
        setCexUrl(url);
        window.addEventListener('message', listener, false);
        setModalOpen(true);
      } else {
        dispatch(addError(''));
      }
    }
  };

  const proposalInfoUpdate = async (proposalId: string) => {
    try {
      if (proposalId) {
        const dashboardInfo = await getDashboard(proposalId);
        if (dashboardInfo.data && dashboardInfo.data.dashboards.length > 0) {
          const proposal = dashboardInfo.data.dashboards[0];
          const operationSelected = {
            data: {
              application: proposal.application,
              merchant_id: proposal.merchant_id,
              product: proposal.product,
              business_status: proposal.business_status,
              business_status_description: proposal.business_status_description,
              order: proposal.order,
              proposal: proposal.proposal,
              loan: proposal.loan,
              customer: proposal.customer,
              created_date: proposal.created_date,
            },
          };
          dispatch(saveOperationData(operationSelected));
          setCommercialOffer(proposal);
          history.push(
            `${OPERATION_DASHBOARD_DETAIL}?credit_proposal_id=${proposalId}`,
          );
        }
      }
    } catch (error) {
      console.error('Error updating proposal info: ', error);
    }
  };

  const handleClick = (value: any) => {
    let newProposal = '';
    if (value === 'rfn') newProposal = commercialOffer?.proposal?.refinanced_credit_proposal_id;
    else if (value === 'loan') newProposal = commercialOffer?.proposal?.following_credit_proposal_id;
    // Se actualiza la información de la operación en función del id seleccionado
    proposalInfoUpdate(newProposal);
  };

  const sendTermsData = () => {
    const pepperOneIframe = document.getElementById(
      'pepper-one-iframe-detail',
    ) as HTMLIFrameElement;
    if (pepperOneIframe?.contentWindow) {
      const commercialOffersStored = sessionStorage.getItem(
        'pepperSimulationCommercialOffers',
      );
      commercialOffersStored
        && pepperOneIframe.contentWindow.postMessage(
          {
            simulationCommercialOffers: JSON.parse(commercialOffersStored),
          },
          '*',
        );
    }
  };

  const handleContinuation = async () => {
    const leadToken = sessionStorage.getItem('leadToken');
    const date = getTodayDate();

    if (
      commercialOffer?.proposal
      || (commercialOffer?.order && commercialOffer?.order?.cart_id)
    ) {
      switch (commercialOffer?.product) {
        case 'CEX':
        case 'PLS':
        case 'SUS':
          if (
            commercialOffer.proposal.status !== 'TUD'
            && (commercialOffer?.created_date === date || commercialOffer.product === 'PLS')
          ) {
            setCexUrl(
              `${URL_CEX}/?lead_token=${leadToken}&credit_proposal_id=${commercialOffer?.proposal.credit_proposal_id
              }${Capacitor.isNativePlatform() ? '&is_app=true' : ''}`,
            );
            setModalOpen(true);
          } else {
            setCexUrl(
              `${URL_CEX}/?lead_token=${leadToken}&credit_proposal_id=${commercialOffer?.proposal.credit_proposal_id
              }&retaken=true${Capacitor.isNativePlatform() ? '&is_app=true' : ''
              }`,
            );
            setModalOpen(true);
          }
          break;
        case 'ECO':
          sessionStorage.setItem('retaken-eco', 'true');
          if (!operationData) {
            dispatch(saveOperationData({ data: commercialOffer }));
          }
          if (commercialOffer?.order) {
            dispatch(saveOperationOrderData(commercialOffer.order));
          }
          openManagedModal();
          break;
        default:
          console.log('DEFAULT CASE');
          break;
      }
    }
    window.addEventListener('message', listener, false);
  };

  const handleRejection = async () => {
    try {
      setIsLoading(true);
      await deleteOperation(creditProposalID
        ?? commercialOffer?.proposal.credit_proposal_id, CancelReason.ACL);
      presentSuccessModal({
        message: 'Operación rechazada correctamente',
        title: '',
        modalSize: true,
        txtButton: 'Continuar',
        padding: '10px',
        onDismiss: () => {
          reloadPage();
        },
      });
    } catch (error: any) {
      if (error?.result?.http_code === 422 && error?.result?.errors.find((err: any) => err.code === 'DRF0013')) {
        reloadPage();
      }
    }
    setIsLoading(false);
  };
  const merchantAndCommercialApiCall = async () => {
    dispatch(clearIsPreferredOffer());
    try {
      const token = sessionStorage.getItem('accessToken');
      let merchantStored = null;
      if (merchantInfo) {
        merchantStored = merchantInfo;
      } else {
        merchantStored = await getMerchants();
        sessionStorage.setItem('Pepper-MerchantData', JSON.stringify(merchantStored));
        dispatch(saveMerchantData(merchantStored));
      }
      Analytics.setAnalyticsUserProperties({
        [ClientTaxonomyProps.USER_ID]: merchantStored.merchant_id,
        [ClientTaxonomyProps.SESSION_ID]: `${merchantStored.merchant_id}_${dayjs().format('YYYYMMDD')}_${token}`,
      });
      setClarityUserId(merchantStored.merchant_id);
      setClaritySessionId(`${merchantStored.merchant_id}_${dayjs().format('YYYYMMDD')}_${token}`);

      setMerchantData(merchantStored);
      if (merchantStored.level === 3) {
        // Si es nivel 3, se comprueban las ofertas comerciales
        const offerS = sessionStorage.getItem('pepper-commercial-offers-S');
        let commercialOffers: FlowCommercialOffer[] | null = null;
        // Si no hay ofertas comerciales en sesión, se consultan
        if (!offerS) {
          // Se consultan las ofertas comerciales
          commercialOffers = await retrieveCommercialOffers();
          if (commercialOffers) {
            // Se guardan en sesión
            sessionStorage.setItem(
              'pepper-commercial-offers-S',
              JSON.stringify(commercialOffers),
            );
          }
        } else {
          commercialOffers = JSON.parse(offerS);
        }
        if (commercialOffers && commercialOffers?.length > 0) {
          commercialOffers.find(
            (offer: FlowCommercialOffer) => offer.flow === FlowType.CEX
              || offer.flow === FlowType.PLS
              || offer.flow === FlowType.SUS,
          ) && dispatch(existingCommercialOffers(true));
          commercialOffers.forEach(async (offer: FlowCommercialOffer) => {
            if (offer.commercial_offers.length > 0) {
              if (offer.flow === FlowType.ECO) {
                // comprueba si hay preferred offer o no preferred offer, si hay de las dos entonces pon a tru preferredOfferandNoPreferredOffer a true, si solo hay preferred offer o solo no preferred offer ponlo a false
                const preferredOffer = offer.commercial_offers.some(
                  (commercialOffer: CommercialOffer) => commercialOffer.is_preferred,
                );
                const noPreferredOffer = offer.commercial_offers.some(
                  (commercialOffer: CommercialOffer) => !commercialOffer.is_preferred,
                );
                dispatch(checkpreferredOfferAndNoPreferredOffer(preferredOffer && noPreferredOffer));
                // Si no hay las dos, entonces guarda si hay preferred offer o no preferred offer
                if (!(preferredOffer && noPreferredOffer)) {
                  if (preferredOffer) {
                    dispatch(saveIsPreferredOffer(true));
                  } else {
                    dispatch(saveIsPreferredOffer(false));
                  }
                }
              }
            }
          });
        }
      }
    } catch (err: any) {
      console.log(err);
    }
  };
  const openManagedModal = () => {
    merchantAndCommercialApiCall();
    presentManagedModal({
      backdropDismiss: false,
      centered: true,
      useCanDismiss: true,
      cartId: cartID,
      onDismiss: () => {
        dispatch(clearOrderManagedData());
        dispatch(clearOperationData());
        setCommercialOffer(null);
        sessionStorage.removeItem('retaken-eco');
        history.replace(OPERATION_DASHBOARD);
      },
    });
  };

  useEffect(() => {
    if (commercialOffer) {
      if (commercialOffer.proposal !== null && commercialOffer.proposal && commercialOffer.proposal.status === 'TUD') {
        setRetakenEco(false);
      }
      if (!operationData?.data) {
        dispatch(saveOperationData(commercialOffer));
      }
      if (commercialOffer.product === 'SUS') {
        setFlowSus(true);
      }
      // isECO && setRetakenEco(true);
      getPurchaseAmount();
    }
  }, [commercialOffer]);

  useEffect(() => {
    if (operationData && operationData.data && !commercialOffer) {
      setCommercialOffer(operationData.data.data!);
    }
  }, [operationData]);

  useEffect(() => {
    if (requestedAmount > 0 && isECO) {
      checkCommercialOfferAvailability(requestedAmount).then((isAvailable) => {
        setRetakenEco(isAvailable);
      });
    }
  }, [requestedAmount]);

  useEffect(() => {
    setIsMobile(!isTablet && !isDesktop);
  }, [isTablet, isDesktop]);

  useEffect(() => {
    const newValue = storageService.hasAGCode();
    if (cookieProposalReference !== newValue) {
      setCookieProposalReference(newValue);
    }
  }, [storageService.hasAGCode()]);

  useEffect(() => {
    if (!commercialOffer) {
      reloadPage();
    }
    if (merchant) {
      setMerchantData(merchant);
    } else {
      const merchantData = sessionStorage.getItem('Pepper-MerchantData');
      setMerchantData(merchantData ? JSON.parse(merchantData) : null);
    }
    if (
      commercialOffer?.loan?.total_refunded
      === commercialOffer?.loan?.requested_amount
    ) {
      setRefundAvailable(false);
    }

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <IonPage className={styles.operationsDetailPage}>
      <IonContent fullscreen className={styles.operationsDetailPageContent}>
        {isLoading && (
          <IonLoading
            isOpen
            spinner="circles"
            className={styles.loading}
          />
        )}
        <div className={styles.pageOperationsDetail}>
          <div className={styles.pageOperationsReturnContainer}>
            <IonIcon
              slot="start"
              icon={chevronBackOutline}
              className={styles.iconBtn}
              onClick={() => history.replace(OPERATION_DASHBOARD)}
            />
            <IonButton
              routerLink={OPERATION_DASHBOARD}
              fill="clear"
              className={styles.btnBack}
              onClick={() => {
                localStorage.removeItem('credit_proposal_id');
                localStorage.removeItem('cart_id');
                dispatch(clearOrderManagedData());
                dispatch(clearOperationData());
                setCommercialOffer(null);
              }}
            >
              Volver a operaciones
            </IonButton>
          </div>
          <div className={styles.pageOperationsCard}>
            <IonCard className={styles.operationsDetailCard}>
              <IonCardHeader className={styles.operationsDetailCardHeader}>
                <IonIcon
                  src={CaretLeftIcon}
                  className={styles.returnMobile}
                  onClick={() => history.replace(OPERATION_DASHBOARD)}
                />
                <IonCardSubtitle className={styles.operationsDetailCardHeaderTitle}>
                  <span className={styles.operationsDetailCardHeaderTitleDni}>
                    {commercialOffer?.customer?.document_id}
                  </span>
                  {screenWidth > 501 && (
                    <span className={styles.operationsDetailCardHeaderTitleSlash}>
                      |
                    </span>
                  )}
                  <span className={styles.operationsDetailCardHeaderTitleName}>
                    {getCustomerFullName(commercialOffer?.customer)}
                  </span>
                </IonCardSubtitle>
                <IonCardSubtitle className={styles.operationsDetailCardHeaderSubtitle}>
                  <IonLabel
                    className={classNames(
                      styles.targetStatusLabel,
                      changeName(commercialOffer?.business_status),
                    )}
                  >
                    {changeName(commercialOffer?.business_status)}
                  </IonLabel>
                </IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent className={styles.principalCard}>
                <div className={styles.operationsDetailContent}>
                  <div className={styles.operationsDetailContentAmounts}>
                    <div className={styles.operationsDetailContentAmountsFinancial}>
                      <IonText className={styles.operationsDetailContentAmountsFinancialText}>
                        Importe financiado
                      </IonText>
                      <IonText className={styles.operationsDetailContentAmountsFinancialTerm}>
                        Plazo:
                        {' '}
                        <span className={styles.financialTerm}>
                          {commercialOffer?.proposal?.term}
                          {' '}
                          meses
                        </span>
                      </IonText>
                    </div>
                    <div className={styles.operationsDetailContentAmountsAmount}>
                      <IonText>
                        {pricesHelper(principalAmount)}
                        {' '}
                      </IonText>
                    </div>
                  </div>
                  <div className={styles.operationsDetailContentButtons}>
                    {commercialOffer?.business_status
                      && handleSelectButton(commercialOffer)}
                  </div>
                </div>
                <hr className={styles.headerSeparator} />
                <div className={styles.operationsDetailContentQuotes}>
                  <div className={styles.operationsDetailContentQuotesMobile}>
                    {/* <div className="operations-detail-content-all-quotes">
                      <span className="operations-detail-content-all-quotes-titles">
                        Primera cuota
                      </span>
                      <span className="operations-detail-content-all-quotes-amount">
                        {commercialOffer?.loan &&
                          commercialOffer?.loan?.fee &&
                          commercialOffer?.proposal?.opening_fee_type === 'N'
                          ? pricesHelper(
                            commercialOffer?.loan.fee +
                            commercialOffer?.loan.opening_fee
                          )
                          : commercialOffer?.loan && commercialOffer?.loan.fee
                            ? pricesHelper(commercialOffer?.loan.fee)
                            : '-'}{' '}
                      </span>
                    </div> */}
                    <div className={styles.operationsDetailContentAllQuotes}>
                      <span className={styles.operationsDetailContentAllQuotesTitles}>
                        Importe cuotas
                      </span>
                      <span className={styles.operationsDetailContentAllQuotesAmount}>
                        {commercialOffer?.loan && commercialOffer?.loan?.fee
                          ? pricesHelper(commercialOffer?.loan?.fee)
                          : '-'}
                        {' '}
                      </span>
                    </div>
                  </div>
                  {commercialOffer?.loan?.created_date && (
                    <div className={styles.operationsDetailContentQuotesMobile}>
                      <div className={styles.operationsDetailContentAllQuotes}>
                        <span className={styles.operationsDetailContentAllQuotesTitles}>
                          Fecha primera cuota
                        </span>
                        <span className={styles.operationsDetailContentAllQuotesAmount}>
                          {convertDateFormatData(
                            commercialOffer?.loan?.created_date,
                          )}
                          {' '}
                        </span>
                      </div>
                      <div className={styles.operationsDetailContentAllQuotes}>
                        <span className={styles.operationsDetailContentAllQuotesTitles}>
                          Fecha última cuota
                        </span>
                        <span className={styles.operationsDetailContentAllQuotesAmount}>
                          {DateAddedMonths(
                            commercialOffer?.loan?.created_date,
                            commercialOffer.loan.term - 1,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                {isMobile && (
                  <div id="mobile-segments-container" className={styles.segmentsContainer}>
                    <IonSegment
                      id="operation-detail-segment"
                      mode="ios"
                      value={segment}
                      onIonChange={(event: any) => {
                        setSegment(event.detail.value);
                      }}
                      className={styles.operationsDetailSegment}
                    >
                      <IonSegmentButton id="operation-detail-button" value={0}>
                        <IonLabel>Detalle operación</IonLabel>
                      </IonSegmentButton>
                      <IonSegmentButton id="operation-detail-button-client" value={1}>
                        <IonLabel>Sobre el cliente</IonLabel>
                      </IonSegmentButton>
                      {commercialOffer?.loan?.refunds?.length > 0
                        && commercialOffer.loan.refunds
                        && (
                          <IonSegmentButton id="operation-detail-button-refunds" value={2}>
                            <IonLabel>Devoluciones</IonLabel>
                          </IonSegmentButton>
                        )}
                    </IonSegment>
                  </div>
                )}

                <div className={styles.operationsDetailInfo}>
                  <IonGrid className={styles.operationsDetailList}>
                    <IonRow className={styles.operationsDetailListRow}>
                      {(segment === 0 || !isMobile) && (
                        <IonCol
                          size="12"
                          size-xl="6"
                          className={styles.operationsDetailInfoDetail}
                        >
                          <IonRow className={styles.operationDetailTitle}>
                            <IonCol size="12" size-lg="6">
                              <IonText className={styles.operationsDetailInfoTitle}>
                                Detalle de la operación
                              </IonText>
                            </IonCol>
                          </IonRow>

                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                Descripción
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsInfo}>
                                {commercialOffer?.order
                                  ? 'Compra en tienda online'
                                  : 'Compra en tienda física'}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                          <hr />
                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                Importe de la compra
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={classNames(
                                styles.operationsDetailListItemsInfo,
                                styles.amount,
                              )}
                              >
                                {pricesHelper(requestedAmount)}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                          {flowSus
                            && commercialOffer
                            && commercialOffer.proposal
                            && commercialOffer.proposal.refinanced_credit_proposal_id && (
                              <>
                                <hr />
                                <IonRow className={styles.operationsDetailListItems}>
                                  <IonCol size="12" size-lg="6">
                                    <IonLabel className={styles.operationsDetailListItemsText}>
                                      Importe refinanciado
                                    </IonLabel>
                                  </IonCol>
                                  {commercialOffer.loan ? (
                                    <IonCol size="12" size-xl="3">
                                      <IonLabel className={classNames(
                                        styles.operationsDetailListItemsInfo,
                                        styles.amount,
                                      )}
                                      >
                                        {commercialOffer?.loan?.refinanced_amount && pricesHelper(commercialOffer?.loan?.refinanced_amount)}
                                      </IonLabel>
                                    </IonCol>
                                  ) : (
                                    <IonCol size="12" size-xl="3">
                                      <IonLabel className="operations-detail-list-items-info amount">
                                        {commercialOffer?.proposal && pricesHelper(
                                          commercialOffer.proposal.principal_amount - commercialOffer.proposal.requested_amount,
                                        )}
                                        {' '}
                                      </IonLabel>
                                    </IonCol>
                                  )}

                                  <IonCol size="12" size-xl="3">
                                    <IonLabel
                                      className={styles.operationsDetailListItemsLink}
                                      onClick={() => handleClick('rfn')}
                                    >
                                      Ver producto
                                    </IonLabel>
                                  </IonCol>
                                </IonRow>
                              </>
                          )}

                          {flowSus
                            && commercialOffer
                            && commercialOffer.proposal
                            && commercialOffer.proposal
                              .following_credit_proposal_id && (
                              <>
                                <hr />
                                <IonRow className={styles.operationsDetailListItems}>
                                  <IonCol size="12" size-lg="6">
                                    <IonLabel className={styles.operationsDetailListItemsText}>
                                      Operación ampliada
                                    </IonLabel>
                                  </IonCol>
                                  <IonCol size="12" size-lg="6">
                                    <IonLabel
                                      className={styles.operationsDetailListItemsLink}
                                      onClick={() => handleClick('loan')}
                                    >
                                      Ver producto
                                    </IonLabel>
                                  </IonCol>
                                </IonRow>
                              </>
                          )}
                          {cookieProposalReference && (
                            <>
                              <hr />
                              <IonRow className={styles.operationsDetailListItems}>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsText}>
                                    Código AG
                                  </IonLabel>
                                </IonCol>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsInfo}>
                                    {
                                      commercialOffer?.proposal
                                        ?.proposal_reference
                                    }
                                  </IonLabel>
                                </IonCol>
                              </IonRow>
                            </>
                          )}
                        </IonCol>
                      )}
                      {(segment === 1 || !isMobile) && (
                        <IonCol
                          size="12"
                          size-lg="12"
                          size-xl="6"
                          className="operations-detail-info--about"
                        >
                          <IonRow className={classNames(
                            styles.operationDetailTitle,
                            styles.secondTitle,
                          )}
                          >
                            <IonCol size="12">
                              <IonText className={styles.operationsDetailInfoTitle}>
                                Sobre el cliente
                              </IonText>
                            </IonCol>
                          </IonRow>
                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                Nombre y apellidos
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsInfo}>
                                {' '}
                                {getCustomerFullName(commercialOffer?.customer)}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                          <hr />
                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                DNI
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsInfo}>
                                {commercialOffer?.customer?.document_id}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                          <hr />
                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                Teléfono
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsInfo}>
                                {commercialOffer?.customer?.phone}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                          <hr />
                          <IonRow className={styles.operationsDetailListItems}>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsText}>
                                Email
                              </IonLabel>
                            </IonCol>
                            <IonCol size="12" size-lg="6">
                              <IonLabel className={styles.operationsDetailListItemsInfo}>
                                {commercialOffer?.customer?.email}
                              </IonLabel>
                            </IonCol>
                          </IonRow>
                        </IonCol>
                      )}
                    </IonRow>
                    {(segment === 2 || !isMobile) && (
                      commercialOffer?.loan?.refunds?.length > 0
                      && commercialOffer.loan.refunds
                        .slice()
                        .reverse()
                        .map((refund: Refund) => (
                          <IonRow className={clsx(styles.operationsDetailListRow, styles.operationsDetailRefundRow)} id="refund-table-row">
                            <IonCol
                              size="12"
                              size-xl="6"
                              className={clsx(styles.operationsDetailInfoDetail)}
                            >
                              <IonRow className={styles.operationDetailTitleRefund}>
                                <IonCol size="12" size-lg="6">
                                  <IonText className={styles.operationsDetailInfoTitle}>
                                    Devolución
                                    {' '}
                                    {refund.refund_type === RefundType.Partial ? 'parcial' : 'total'}
                                  </IonText>
                                </IonCol>
                              </IonRow>

                              <IonRow className={styles.operationsDetailListItems}>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsText}>
                                    Fecha de la devolución
                                  </IonLabel>
                                </IonCol>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsInfo}>
                                    {dayjs(new Date(refund.created_date)).format('DD/MM/YY')}
                                  </IonLabel>
                                </IonCol>
                              </IonRow>
                              <hr />
                              <IonRow className={styles.operationsDetailListItems}>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsText}>
                                    Estado
                                  </IonLabel>
                                </IonCol>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={classNames(
                                    styles.operationsDetailListItemsInfo,
                                    styles.amount,
                                  )}
                                  >
                                    {RefundStatus[refund.refund_status as keyof typeof RefundStatus]}
                                  </IonLabel>
                                </IonCol>
                              </IonRow>
                              <hr />
                              <IonRow className={styles.operationsDetailListItems}>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={styles.operationsDetailListItemsText}>
                                    Importe de la devolución
                                  </IonLabel>
                                </IonCol>
                                <IonCol size="12" size-lg="6">
                                  <IonLabel className={classNames(
                                    styles.operationsDetailListItemsInfo,
                                    styles.amount,
                                  )}
                                  >
                                    {pricesHelper(refund.refund_amount)}
                                  </IonLabel>
                                </IonCol>
                              </IonRow>
                            </IonCol>
                          </IonRow>
                        )))}
                  </IonGrid>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
          <IonModal
            isOpen={modalOpen}
            backdropDismiss={false}
            id="pepper-one-modal"
            onDidDismiss={() => setModalOpen(false)}
            className={styles.pepperModalDetail}
          >
            <iframe
              src={cexUrl}
              id="pepper-one-iframe-detail"
              className={styles.pepperIframe}
              title="pepperone"
              allow="microphone; camera; midi; encrypted-media;"
              width="100%"
              height="100%"
              onLoad={sendTermsData}
            />
          </IonModal>
          <div className={styles.operationsDetailContentButtonsMobile} id="contentButtonsMobile">
            {commercialOffer?.business_status
              && handleSelectButton(commercialOffer)}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
